/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DateControls.vue?vue&type=template&id=5fae96eb&scoped=true"
import script from "./DateControls.vue?vue&type=script&lang=js"
export * from "./DateControls.vue?vue&type=script&lang=js"
import style0 from "./DateControls.vue?vue&type=style&index=0&id=5fae96eb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fae96eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fae96eb')) {
      api.createRecord('5fae96eb', component.options)
    } else {
      api.reload('5fae96eb', component.options)
    }
    module.hot.accept("./DateControls.vue?vue&type=template&id=5fae96eb&scoped=true", function () {
      api.rerender('5fae96eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patient-reassignment/DateControls.vue"
export default component.exports